import { Button } from '../button/Button';
import styles from './PlayerPoolCard.module.css';

type Member = { name: string; status: string };

type Props = {
  members: Member[];
  isModerator: boolean;
  onKick: (name: string) => void;
};

export function PlayerPoolCard({ members, isModerator, onKick }: Props) {
  const active = members.filter((m) => m.status === 'active');

  if (active.length === 0) {
    return (
      <div className={styles.pool}>
        <p className={styles.empty}>No players yet.</p>
      </div>
    );
  }

  return (
    <div className={styles.pool}>
      <ul className={styles.list}>
        {active.map((m) => (
          <li key={m.name} className={styles.item}>
            <span className={styles.name}>{m.name}</span>
            {isModerator && (
              <Button variant="danger" onClick={() => onKick(m.name)}>
                Kick
              </Button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
